import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from '../../service/app.layout.service';

@Component({
    selector: 'app-menu',
    templateUrl: './app.menu.component.html'
})
export class AppMenuComponent implements OnInit {

    model: any[] = [];

    constructor(public layoutService: LayoutService) { }

    ngOnInit() {
        this.model = [
            {
                label: 'Amministrazione',
                items: [
                    { label: 'Insegne', icon: 'pi pi-fw pi-user', routerLink: ['/amministrazione/insegne'] },
                    { label: 'Volantini', icon: 'pi pi-fw pi-images', routerLink: ['/amministrazione/volantini'] },
                ]
            }
        ];
    }
}
